/* eslint-disable */
export default {
  notActivated: 'Inactif',
} as const;

// @key: @#@"notActivated"@#@ @source: @#@"Inactive"@#@
